<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncShow :funInfo="funInfo"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/takeaway/phone.png'),
        title: 'CPS外卖',
        desc: "为您提供美团、饿了么的外卖点餐服务"
      },
      funInfo: {
        title: 'CPS外卖',
        list: [
          {
            title: '美团',
            img: require('@/assets/images/index/takeaway/img1.png'),
            text: '用智莺系统，不仅提供美团外卖红包、美团到店优惠券、美团本地返现美团商超百万补贴，下单还能领返佣实实在在省钱'
          },
          {
            title: '饿了么',
            img: require('@/assets/images/index/takeaway/img2.png'),
            text: '不需要购买饿了么会员，就能天天领红包，超值优惠天天领，下单还能领返佣实实在在省钱'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
